import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import styled from "theme/libs/styled";

const Wrapper = styled("div")`
    position: relative;
    padding: 12px;

    &[data-is-disabled="true"] {
        pointer-events: none;
        opacity: 0.5;
    }
`;

const Input = styled("input")`
    -webkit-appearance: checkbox;
    width: auto;
    display: none;

    &:checked + label::after {
        position: absolute;
        content: "";
        width: 16px;
        height: 16px;
        left: 4px;
        border-radius: 50%;
        background: ${({ theme }) => theme.colors.black};
    }
`;

const Label = styled("label")`
    --input-width: 20px;
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    color: ${({ theme }) => theme.colors.black_50};
    user-select: none;
    cursor: pointer;
    padding-left: calc(var(--input-width) + 12px);

    &::before {
        position: absolute;
        content: "";
        width: var(--input-width);
        height: var(--input-width);
        left: 2px;
        border-radius: 50%;
        border: 1px solid ${({ theme }) => theme.colors.black};
    }

    &[data-checked="true"] {
        text-decoration: underline;
        color: ${({ theme }) => theme.colors.black};
    }
`;

const Radio = ({ id, name, value, children, isChecked, disabled, ...props }) => {
    const [checked, setChecked] = useState(isChecked);

    useEffect(() => {
        if (checked !== isChecked) {
            setChecked(isChecked);
        }
    }, [checked, isChecked]);

    const onChange = ({ target }) => {
        setChecked(target.checked);

        props.onChange && props.onChange(target.checked ? value : null);
    };

    return (
        <Wrapper data-checked={checked} data-is-disabled={disabled}>
            <Input hidden checked={checked} type="radio" id={id} name={name} value={value} onChange={onChange} />
            <Label htmlFor={id} data-checked={checked}>
                {children}
            </Label>
        </Wrapper>
    );
};

Radio.propTypes = {
    children: PropTypes.node,
    disabled: PropTypes.bool,
    id: PropTypes.string.isRequired,
    isChecked: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
};

Radio.defaultProps = {
    children: null,
    disabled: false,
    isChecked: false,
    name: null,
    value: null,
};

export default Radio;
